import cookie from 'react-cookies';
import {saveCookie} from "@baseHelpers/cookie";
import {$http} from "@http";
import {isEmpty} from "@helpers/helpers";
import {str_replace} from "@helpers/helpers";
import {getFile} from "./media";
import {array_unique, inArray, is_array} from "../components/helpers/arrays";
import {getCurrentTime} from "../components/helpers/dates";
import {httpBuildQuery} from "../components/helpers/helpers";
import {getCacheKey} from "./cache_key";

const cacheTable = 'districts';

/**
 * @param city_id
 *
 * @return Promise {districts}
 * */
var Districts = null;
var CityId = null;

function getDistricts(city_id) {
    const path = 'v1/districts/' + city_id + '/districts';
    const cacheKey = getCacheKey(cacheTable, 'allDistrictsByCity', 'city-id', [city_id]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        if (city_id && CityId !== Number(city_id)) {
            return get();
        } else if (!isEmpty(Districts)) {
            resolve(Districts);
        } else {
            return get();
        }

        function get() {
            let localDistricts = null;

            if (process.browser) {
                localDistricts = localStorage.getItem('districts');
            }

            if (!isEmpty(localDistricts)) {
                localDistricts = JSON.parse(localDistricts);
            }

            if (!isEmpty(localDistricts) && Number(localDistricts.city_id) === Number(city_id)) {
                Districts = localDistricts.lists;

                Districts = sortDistricts(Districts.districts);
                resolve(Districts);
            } else {

                $http(cacheKey, path, cacheTTL).then(result => {
                    CityId = Number(city_id);
                    Districts = result;

                    if (process.browser) {
                        const storeData = {
                            city_id: city_id,
                            lists: Districts,
                            expire: getCurrentTime(24 * 60 * 60) // 1 day
                        };

                        localStorage.setItem('districts', JSON.stringify(storeData));
                    }

                    Districts = sortDistricts(Districts.districts);

                    resolve(Districts);
                }).catch(err => {
                    reject(err)
                })
            }
        }
    });
}

/**
 * @param district_id
 *
 * @return Promise district
 * */
var getDistrictRequest = true;

function getDistrict(district_id) {
    const path = '/v1/districts/' + district_id + '/get';
    let getFromApi = false;
    const cacheKey = getCacheKey(cacheTable, 'lists', 'id', [district_id]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {

        if (process.browser) {
            let localDistricts = localStorage.getItem('districts');
            if (!isEmpty(localDistricts)) {
                localDistricts = JSON.parse(localDistricts);
                const districtLists = localDistricts.lists;

                const district = districtLists.districts.filter(district => {
                    if (district && Number(district.id) === Number(district_id)) {
                        return district
                    }
                });

                if (!isEmpty(district[0])) {
                    getDistrictRequest = true;
                    resolve(district[0]);
                } else {
                    getFromApi = true;
                }
            } else {
                getFromApi = true;
            }
        } else {
            getDistrictRequest = true;
            getFromApi = true;
        }

        if (getFromApi) {

            $http(cacheKey, path, cacheTTL).then(result => {
                resolve(result.district);
            }).catch(err => {
                reject(err)
            })
        }

    })
}

/**
 * @param id {number}
 * @param type {string}
 *
 * @return Promise
 * */
var getOverlappingRequest = true;

function getOverlapping(id, type) {
    const path = '/v1/districts/' + id + '/overlapping/' + type;
    const cacheKey = getCacheKey(cacheTable, 'overlapping', 'district-type', [id, type]);
    const cacheTTL = 24 * 60 * 60; // second


    return new Promise((resolve, reject) => {
        if (getOverlappingRequest) {
            getOverlappingRequest = false;

            $http(cacheKey, path, cacheTTL).then(result => {
                getOverlappingRequest = true;
                resolve(result)
            }).catch(err => {
                reject(err)
            })
        }
    })
}

/**
 * @param area_id {number}
 *
 * @return Promise
 * */

function getCitiesOfArea(area_id) {
    const path = '/v1/districts/' + area_id + '/cities';
    const cacheKey = getCacheKey(cacheTable, 'citiesOfArea', 'area', [area_id]);
    const cacheTTL = 24 * 60 * 60; // second


    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @return Promise
 * */
let getCitiesRequest = false;

function getCities() {
    const path = 'v1/districts/cities';
    const cacheKey = getCacheKey(cacheTable, 'cities', 'all', []);
    const cacheTTL = 24 * 60 * 60; // second


    return new Promise((resolve, reject) => {

        if (!getCitiesRequest) {
            getCitiesRequest = true;

            $http(cacheKey, path, cacheTTL).then(cities => {
                if (process.browser) {
                    cities['expire'] = getCurrentTime(24 * 60 * 60); // 1 day
                    localStorage.setItem('cities_lists', JSON.stringify(cities));
                }

                getCitiesRequest = false;
                resolve(cities);
            })
        } else {
            reject(null)
        }
    })
}

/**
 * @param districts {Array}
 * @param with_geo {Boolean}
 *
 * @return Promise
 * */
export function getAroundDistricts(districts, with_geo = false) {
    let path = '/v1/districts/around/districts';

    let data = {
        district_id: districts,
    };

    if (with_geo) {
        data['with_geo'] = 1
    }

    path = path + '?' + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'aroundDistricts', 'districts', [districts, (with_geo ? '1' : '0')]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param districts {Array}
 * @param count {Number}
 *
 * @return Promise
 * */
export function getTopNearestDistricts(districts, count) {
    let path = '/v1/districts/nearest/topDistricts';

    let data = {
        district_id: districts,
        count: count
    };

    path = path + '?' + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'topNearest', 'districts', [districts, count]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param city_id {Number}
 * @param count {Number}
 *
 * @return Promise
 * */
export function getTopCrowdedDistricts(city_id, count) {
    let path = '/v1/districts/' + city_id + '/crowdedDistricts' + (!isEmpty(count) ? '?count=' + count : '');

    const cacheKey = getCacheKey(cacheTable, 'topCrowdedDistricts', 'city', [city_id, count]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/*
* *****************************  Helpers  **********************
* */

/**
 * @param city_id {null|int}
 *
 * */

function getCitiesLists(city_id = null) {

    return new Promise((resolve, reject) => {

        let localCities = null;
        if (process.browser) {
            localCities = localStorage.getItem('cities_lists');
        }

        if (!isEmpty(localCities)) {

            if (!isEmpty(city_id)) {
                resolve(getCity(city_id))
            } else {
                localCities = JSON.parse(localCities);
                resolve(localCities);
            }
        } else {
            getCities().then(result => {
                if (!isEmpty(city_id)) {

                    const city = result.cities.filter(city => {
                        if (city && Number(city.id) === Number(city_id)) {
                            return city;
                        }
                    });

                    resolve(city[0]);
                } else {
                    resolve(result);
                }
            }).catch(err => {
                reject(err)
            })
        }
    })
}

/**
 * @param city_id
 *
 * @return Promise
 * */
async function getCityById(city_id) {
    if (!process.browser) {
        return await getDistrict(city_id)
    } else {
        let city = getCity(city_id);

        if (!isEmpty(city)) {
            return city
        } else {
            return await getCitiesLists(city_id);
        }
    }
}

/**
 * @param city_name {String}
 *
 * @return Promise
 * */
export async function getCityByName(city_name) {
    const cities = await getCitiesLists();

    const city = cities.cities.filter(item => {
        if (item.name == city_name) {
            return item;
        }
    });

    return (city && is_array(city)) ? city[0] : null;
}

/**
 * @param city_id {Number|String}
 *
 * @return Object
 * */
function getCity(city_id) {
    if (process.browser && !isEmpty(localStorage.getItem('cities_lists'))) {
        let cities = JSON.parse(localStorage.getItem('cities_lists'));

        if (!isEmpty(cities) && !isEmpty(cities.cities)) {
            const city = cities.cities.filter(item => {
                if (item && Number(item.id) === Number(city_id)) {
                    return item;
                }
            });

            if (!isEmpty(city)) {
                return city[0];
            }
        }
    }

    return null;
}

async function getCityURL($city, encode = false) {
    let $url = '';

    if (!isNaN(Number($city))) {
        const city = await getCityById($city);

        if (!isEmpty(city)) {
            $url += 'املاک-' + str_replace(' ', '-', city.name);
        }
    } else if (!isEmpty($city)) {
        $url += 'املاک-' + str_replace(' ', '-', $city);
    }

    if (encode) {
        return encodeURI($url)
    }

    return $url;
}

function setDefaultCity(city_id, ctx = null) {

    if (!isEmpty(city_id)) {
        if (process.browser) {
            const city = getCity(city_id);

            if (!isEmpty(city)) {
                localStorage.removeItem('default_city');

                city['expire'] = getCurrentTime(24 * 60 * 60); // 1 day
                localStorage.setItem('default_city', JSON.stringify(city));
            }

            cookie.remove('default_city_id');
            saveCookie('default_city_id', city_id);
        } else if (!isEmpty(ctx) && !isEmpty(ctx.res)) {
            ctx.res.cookie('default_city_id', city_id, {maxAge: 2592000000, httpOnly: false, secure: false, path: '/'}); // 30 day
        }
    }
}

/**
 * @param  district_id {number}
 *
 * @return String
 * */
function getDistrictImage(district_id) {
    return getFile('/districts/' + district_id + '.jpg');
}

export function sortDistricts(districts) {
    let recent_districts = cookie.load('recent_districts');
    let sort = [];

    if (!isEmpty(recent_districts) && recent_districts !== 'undefined') {
        recent_districts = recent_districts.split(',');

        if (is_array(recent_districts)) {
            for (let key in districts) {
                const district = districts[key];

                if (inArray(district.id, recent_districts)) {
                    sort.push(district);
                    delete districts[key];
                }
            }
        }
    }

    sort = [...sort, ...array_unique(districts)];

    return {districts: sort};
}

export {
    getCity,
    getCityById,
    getCityURL,
    getDistricts,
    getDistrict,
    getOverlapping,
    getCitiesOfArea,
    getCitiesLists,
    setDefaultCity,
    getDistrictImage
}